<template>
  <nav v-if="mode === 'pages' && totalPages > 1" class="rh-pager">
    <button
      class="rh-pager-btn"
      type="button"
      :disabled="page <= 1"
      @click="emit('go', page - 1)"
    >
      ‹
    </button>
    <button
      v-for="p in visiblePages"
      :key="p"
      type="button"
      class="rh-pager-btn"
      :class="{ 'rh-pager-btn-active': p === page }"
      @click="emit('go', p)"
    >
      {{ p }}
    </button>
    <button
      class="rh-pager-btn"
      type="button"
      :disabled="page >= totalPages"
      @click="emit('go', page + 1)"
    >
      ›
    </button>
  </nav>
  <div v-else-if="mode === 'lazy' && hasMore" class="rh-pager">
    <button
      type="button"
      class="rh-load-more"
      :disabled="loading"
      @click="emit('more')"
    >
      {{ loading ? 'Загрузка…' : 'Показать ещё' }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { PaginationMode } from '../types';

const props = defineProps<{
  mode: PaginationMode;
  page: number;
  total: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
}>();

const emit = defineEmits<{
  go: [page: number];
  more: [];
}>();

const totalPages = computed(() =>
  Math.max(1, Math.ceil(props.total / props.pageSize)),
);

const visiblePages = computed<number[]>(() => {
  const last = totalPages.value;
  const cur = props.page;
  const range = new Set<number>([1, last, cur, cur - 1, cur + 1]);
  return Array.from(range)
    .filter((p) => p >= 1 && p <= last)
    .sort((a, b) => a - b);
});
</script>
